import got from "got";

const client = got.extend({
  headers: {
    Referer: "https://www.youtube.com",
    "User-Agent": "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/114.0.0.0 Safari/537.36",
  },
})

export default client;